import { Constants } from "src/app/core/constants/constants";
import { IDynamicFormBlock } from "src/app/core/models/dynamic-form-block.vm";
import { IDynamicChangeList } from "src/app/core/models/dynamic-table-change-list.vm";
import { IDynamicTableColumn } from "src/app/core/models/dynamic-table-column.vm";

export const EventRegistrationDetailsForm: IDynamicFormBlock[] = [
    {
        blockType: 'divider'
    },
    {
        label: 'Registration Details',
        blockType: 'header',
        colWidth: 12
    },
    {
        blockType: 'break'
    },
    {
        label: 'Name',
        dataKey: 'fullName',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Email',
        dataKey: 'emailAddress',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Job Title',
        dataKey: 'jobTitle',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Contact Number',
        dataKey: 'contactNo',
        blockType: 'input',
        inputType: 'number',
        colWidth: 6,
    },
    {
        label: 'Twitter',
        dataKey: 'twitterHandle',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Organisations',
        dataKey: 'organisationId',
        blockType: 'searchDropdown',
        colWidth: 6,
        optionsType: 'organisations'
    },
    {
        blockType: 'divider'
    }, 
    {
        label: 'Status',
        dataKey: 'status',
        blockType: 'select',
        colWidth: 6,
        options: Constants.registrationStatus,
    },
    {
        label: 'Attended',
        dataKey: 'attended',
        blockType: 'select',
        colWidth: 6,
        disabled: true,
        options: Constants.attendedStatus,
    },  
    {
        label: 'Dietary Requirements',
        dataKey: 'dietaryRequirements',
        blockType: 'select',
        colWidth: 6,
        options: Constants.dietaryRequirements,
    },
    {
        label: 'Dietary Details',
        dataKey: 'dietaryDetails',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Access Requirements',
        dataKey: 'accessRequirements',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Event ID',
        dataKey: 'eventId',
        blockType: 'input',
        colWidth: 6,
        disabled: true
    },
    {
        label: 'Member',
        dataKey: 'isMember',
        blockType: 'select',
        options: Constants.yesNo,
        colWidth: 6,
    },
    {
        label: 'Delegate List',
        dataKey: 'delegateList',
        blockType: 'select',
        options: Constants.yesNo,
        colWidth: 6,
    },
    {
        blockType: 'divider'
    },
    {
        label: 'Registrant Details',
        blockType: 'header',
        colWidth: 12
    },
    {
        blockType: 'break'
    },
    {
        label: 'Registrant',
        dataKey: 'registeringUserFullName',
        blockType: 'input',
        colWidth: 6,
        disabled: true
    },
    {
        label: 'Admin User ID',
        dataKey: 'userId',
        disabled: true,
        inputType: 'number',
        blockType: 'input',
        colWidth: 6,
    },
    {
        label: 'Registrant Email',
        dataKey: 'registeringUserLogonName',
        blockType: 'input',
        colWidth: 6,
        disabled: true
    },
    {
        label: 'Registration Date',
        dataKey: 'registrationDt',
        blockType: 'input',
        disabled: true,
        colWidth: 6,
    },
    {
        label: 'Registration ID',
        dataKey: 'registrationId',
        blockType: 'input',
        colWidth: 6,
        disabled: true
    },
    {
        blockType: 'divider'
    }, 
    {
        label: 'Update Details',
        blockType: 'saveButton',
        action: 'editDelegate',
        colWidth: 6
    },
]


export const RegistrationTableUpdate: IDynamicChangeList[] = [
    {
        header: 'Events',
        name: 'Registrations',
        currentList: 'R',
        hideValue: true,
        displayHelpText: false
    },
    {
        header: 'Events',
        name: 'Non Member Registration Requests',
        currentList: 'PENDING',
        hideValue: true,
        displayHelpText: false
    }
];

export const EventRegistrationTableColumns: IDynamicTableColumn[] = [
    {
        header: 'Name',
        dataKey: 'fullName',
        percWidth: 25,
        sortable: true,
        groupable: false,
        searchable: true,
    },
    {
        header: 'Member',
        dataKey: 'isMember',
        percWidth: 15,
        sortable: true,
        groupable: true,
        searchable: false,
        badge: 'yesNo'
    },
    {
        header: 'Email',
        dataKey: 'emailAddress',
        percWidth: 35,
        sortable: true,
        groupable: false,
        searchable: true
    },
    {
        header: 'Job Title',
        dataKey: 'jobTitle',
        percWidth: 35,
        sortable: true,
        groupable: false,
        searchable: true
    },
    {
        header: 'Organisation Name',
        dataKey: 'organisationName',
        percWidth: 25,
        sortable: true,
        groupable: false,
        searchable: true,
    },    
    {
        header: 'Attended',
        dataKey: 'attended',
        percWidth: 15,
        sortable: true,
        groupable: true,
        searchable: false,
        badge: 'yesNo'
    },
    {
        header: 'Dietary Requirements (hidden)',
        dataKey: 'dietaryRequirements',
        percWidth: 0,
        sortable: false,
        groupable: false,
        searchable: false
    },
    {
        header: 'Dietary Details (hidden)',
        dataKey: 'dietaryDetails',
        percWidth: 0,
        sortable: false,
        groupable: false,
        searchable: false,
    },
];

export const AddDelegateFormBlock: IDynamicFormBlock[] = [
    {
        blockType: 'divider'
    },
    {
        label: 'Product Details',
        blockType: 'header',
        colWidth: 12
    },
    {
        label: 'Name',
        dataKey: 'delegateName',
        helpText: "Required",
        blockType: 'input',
        colWidth: 12,
    },
    {
        label: 'Email',
        dataKey: 'delegateEmail',
        helpText: "Required",
        blockType: 'input',
        colWidth: 12,
    },
    {
        label: 'Job Title',
        dataKey: 'delegateJobTitle',
        helpText: "Required",
        blockType: 'input',
        colWidth: 12,
    },
    {
        label: 'Organisations',
        dataKey: 'organisationId',
        helpText: "Required",
        blockType: 'searchDropdown',
        colWidth: 12,
        optionsType: 'organisations'
    },
    {
        label: 'Member',
        dataKey: 'isMember',
        helpText: "Required",
        blockType: 'select',
        options: Constants.yesNo,
        colWidth: 12,
    },
    {
        label: 'Contact Number',
        dataKey: 'delegateContactNo',
        blockType: 'input',
        inputType: 'number',
        colWidth: 12,
    },
    {
        label: 'Twitter',
        dataKey: 'twitterHandle',
        blockType: 'input',
        colWidth: 12,
    },
    {
        label: 'Dietary Details',
        dataKey: 'dietaryDetails',
        blockType: 'input',
        colWidth: 12,
    },
    {
        label: 'Dietary Requirements',
        dataKey: 'dietaryRequirements',
        blockType: 'select',
        options: Constants.dietaryRequirements,
        colWidth: 12,
    },
    {
        label: 'Access Requirements',
        dataKey: 'accessRequirements',
        blockType: 'input',
        colWidth: 12,
    },
    {
        label: 'Delegate List',
        dataKey: 'delegateList',
        blockType: 'select',
        options: Constants.yesNo,
        colWidth: 12,
    },
    {
        label: 'Submit',
        blockType: 'saveButton',
        action: 'addDelegate',
        dataKeys: ['organisationId','delegateEmail','delegateName','delegateJobTitle', 'isMember'],
        colWidth: 6
    }
]